<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Logo công ty">
          <div slot="content" class="container-fuild">
            <div class="row">
              <div class="form-group col-4">
                <img style="max-height: 150px;" v-if="logo" :src="'https://crm.ity.vn' + logo.logo"/>
                <span v-else>Chưa có logo cho công ty</span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-4">
                <label>Cập nhật logo công ty</label>
                <div class="dropbox">
                  <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
                    <input type="file"
                           :name="uploadFieldName"
                           :disabled="isSaving"
                           @change="filesChange($event.target.name, $event.target.files)"
                           accept="image/*" class="input-file"/>
                    <p v-if="isInitial">
                      Thả file ảnh vào đây<br> hoặc click để lựa chọn ảnh
                    </p>
                    <p v-if="isSaving">
                      Đang tải file lên...
                    </p>
                  </form>
                  <div v-if="isSuccess">
                    <h2>Tải lên thành công.</h2>
                    <p>
                      <a href="javascript:void(0)" @click="reset()">Sửa</a>
                    </p>
                    <ul class="list-unstyled">
                      <li v-for="(item, idx) in uploadedFiles" :key="idx">
                        <img style="max-height: 150px;" :src="item.url" class="img-responsive img-thumbnail" :alt="item.originalName" />
                      </li>
                    </ul>
                  </div>
                </div>
                <div v-if="isFailed">
                  <h2>Uploaded failed.</h2>
                  <p>
                    <a href="javascript:void(0)" @click="reset()">Thử lại</a>
                  </p>
                  <pre>{{ uploadError }}</pre>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <b-button class="btn btn-sm btn-warning" @click="$router.back()">
                  <span class="glyphicon glyphicon-backward" aria-hidden="true"></span> Quay lại
                </b-button>
                <b-button class="btn btn-sm btn-danger" @click="add()">
                  <span class="glyphicon glyphicon-upload" aria-hidden="true"></span> Tải lên
                </b-button>
              </div>
            </div>
          </div>
        </va-box>
      </div>
    </section>
  </div>
</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import Utils from '../../common/utils'
import VAModal from '../../components/VAModal'
import {mapGetters} from 'vuex'
import CompanyLogoApi from '../../api/companyLogo'

const STATUS_INITIAL = 0
const STATUS_SAVING = 1
const STATUS_SUCCESS = 2
const STATUS_FAILED = 3

export default {
  name: 'CompanyLogo',
  components: {
    VAModal,
    'va-box': VABox,
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'editPermission'
    ]),
    isInitial () {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving () {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      loading: false,
      logo: null,
      company_id: 0,
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'photos',
      formData: null,
    }
  },
  mounted () {
    const company = Utils.getCompanyByUserInfo(this.userInfo)
    this.company_id = company.id
    this.filter()
    this.reset()
  },
  methods: {
    filter () {
      if (this.loading) {
        return
      }
      this.loading = true
      CompanyLogoApi.get(this.company_id).then(res => {
        this.logo = res.data.data
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
      }).finally(() => {
        this.loading = false
      })
    },
    reset () {
      this.currentStatus = STATUS_INITIAL
      this.uploadedFiles = []
      this.uploadError = null
    },
    save (formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING
      CompanyLogoApi.upload(formData)
        .then(x => {
          this.uploadedFiles = [].concat(x)
          this.currentStatus = STATUS_SUCCESS
        })
        .catch(err => {
          this.uploadError = err.response
          this.currentStatus = STATUS_FAILED
        })
    },
    filesChange (fieldName, fileList) {
      // handle file changes
      const formData = new FormData()
      if (!fileList.length) return
      // append the files to FormData
      Array
        .from(Array(fileList.length).keys())
        .map(x => {
          formData.append(fieldName, fileList[x], fileList[x].name)
        })
      this.formData = formData
      // upload here
      this.save(formData)
    },
    add () {
      // add new
      if (!this.logo && this.formData) {
        this.loading = true
        const fd = new FormData()
        fd.set('company_id', this.company_id)
        fd.set('logo', this.formData.get('photos'))
        CompanyLogoApi.create(fd)
          .then((res) => {
            this.logo = res.data.data
            Utils.successToast(this.$bvToast)
          })
          .catch(err => {
            Utils.handleError(this.$bvToast, err)
          })
          .finally(() => {
            this.loading = false
            this.reset()
          })
      }
      if (this.logo && this.formData) {
        this.loading = true
        const fd = new FormData()
        fd.set('id', this.logo.id)
        fd.set('company_id', this.company_id)
        fd.set('logo', this.formData.get('photos'))
        CompanyLogoApi.update(fd)
          .then((res) => {
            this.logo = res.data.data
            Utils.successToast(this.$bvToast)
          })
          .catch(err => {
            Utils.handleError(this.$bvToast, err)
          })
          .finally(() => {
            this.loading = false
            this.reset()
          })
      }
    }
  }
}
</script>

<style scoped>
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/CompanyLogo.vue